export const scanMixin = {
  methods: {
    validateScanType({ type, q }) {
      switch (type) {
        case 'shelfSpace':
          return /^[A-Z][0-9][0-9][0-9]$/.test(q)
        case 'boxSpace':
          return /W[0-9]-[0-9][0-9]/.test(q)
        case 'productId':
          return /A[0-9][0-9][0-9][0-9]/.test(q) || /a[0-9][0-9][0-9][0-9]/.test(q)
        case 'ean':
          return /^\d+$/.test(q)
      }
    },
    getScanResult({ type, q }) {
      switch (type) {
        case 'shelfSpace': {
          const shelf = _.find(this.$store.state.shelves, { id: q.substr(0, 2) })
          if (shelf) return shelf.spaces[q.substr(2, 2)] ? shelf.spaces[q.substr(2, 2)].items : null
          return null
        }
        case 'boxSpace':
          return 'BOX'
        case 'productId':
          return _.find(this.$store.state.products, { id: q.toUpperCase() })
        case 'ean':
          return _.find(this.$store.state.products, { eans: [{ ean: q }] })
      }
    }
  }
}
